import { createPushSubscription, deletePushSubscription } from '../../../api/user';
import { urlBase64ToUint8Array } from '../../../helpers/general';
import * as Types from '../../actions/types';
import { put, takeLatest, call, delay } from 'redux-saga/effects';
import {
  pushNotificationsSubscribe as tryPushNotificationsSubscribe,
  pushNotificationsUnsubscribe as tryPushNotificationsUnsubscribe
} from '../../actions/user';

function* pushNotificationsSubscribe(action) {
  try {
    if ('Notification' in window && navigator.serviceWorker) {
      const permission = yield call(Notification.requestPermission);

      if (permission === 'granted') {
        const registration = yield call([navigator.serviceWorker, 'register'], '/js/pushNotificationsWorker.js');
        const subscription = yield call([registration.pushManager, 'subscribe'], {
          userVisibleOnly: true,
          applicationServerKey: urlBase64ToUint8Array(process.env.REACT_APP_VAPID_PUBLIC_KEY),
        });
        const response = yield call(createPushSubscription, {data: JSON.stringify(subscription)});
        
        if (response.status !== 201) {
          yield delay(10000);
          yield put(tryPushNotificationsSubscribe());
        }
      }
    }
  } catch (e) {
    yield delay(10000);
    yield put(tryPushNotificationsSubscribe());
  }
}

function* pushNotificationsUnsubscribe(action) {
  try {
    if ('Notification' in window && navigator.serviceWorker) {
      const registration = yield call([navigator.serviceWorker, 'getRegistration']);
      const subscription = yield call([registration.pushManager, 'getSubscription']);
      if (subscription) {
        yield call([subscription, 'unsubscribe']);

      }

      const response = yield call(deletePushSubscription, {data: JSON.stringify(subscription)});
        
      if (response.status !== 204) {
        yield delay(10000);
        yield put(tryPushNotificationsUnsubscribe());
      }
    }
  } catch (e) {
    yield delay(10000);
    yield put(tryPushNotificationsUnsubscribe());
  }
}

export default function* socketAuthSaga() {
  yield takeLatest( Types.PUSH_NOTIFICATIONS_SUBSCRIBE, pushNotificationsSubscribe );
  yield takeLatest( Types.PUSH_NOTIFICATIONS_UNSUBSCRIBE, pushNotificationsUnsubscribe );
}